import axios from "axios";
const reqUrl = "https://psbcpay.kunxiangparking.cn/roadside"; //路侧服务
const request = axios.create({
  baseURL: reqUrl,
  headers: { "Content-Type": "application/json" },
  timeout: 30 * 1000
});

// 请求拦截器

request.interceptors.request.use(
  config => {
    console.log(config);
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function(error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);
export default request;
